<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-cart">
    <div class="vx-col w-full sm:w-3/4 md:w-2/3 lg:w-3/4 xl:w-3/5" v-if="!showDone">
      <vx-card title="Order Form" title-color="primary" v-if="showOrder">
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg" >
              <div class="p-6">

                <vs-collapse type="border">

                    <vs-collapse-item>
                        <div slot="header" class="flex">
                            <h5>Show Order Summary</h5>
                            <p class="ml-auto mr-8 text-primary"><strong>RM {{grandTotal}}</strong></p>
                        </div>

                        <div class="vx-row text-xs md:text-base"  v-for='product in products' :key='product.id' >
                            <div class="vx-col w-1/2">
                            <p>{{product.name}} ({{product.quantity}} )</p>
                            </div>
                            <div class="vx-col w-1/2 text-right">
                            <p>RM {{parseInt(product.price_perquantity*product.quantity).toFixed(2)}}</p>
                            </div>
                        </div>

                         <div class="vx-row text-xs md:text-base">
                        <div class="vx-col w-1/2">
                            <p>Shipping ({{shippingLabel}})</p>
                            </div>
                            <div class="vx-col w-1/2 text-right">
                            <p>RM {{shippingFees}}</p>
                            </div>
                        </div>
                        <vs-divider/>
                        <div class="vx-row text-xs md:text-base">
                            <div class="vx-col w-3/5 lg:w-4/5 text-right">
                            <P>Subtotal :</p>
                            <p>Tax :</p>
                            <p>Coupon Discount :</p>
                            <p><strong>Total :</strong></p>
                            </div>
                            <div class="vx-col w-2/5 lg:w-1/5 text-right">
                            <p>RM {{subTotal}}</p>
                            <p>0 %</p>
                            <p>- RM {{discount}}</p>
                            <p><strong>RM {{grandTotal}}</strong></p>
                            </div>
                        </div>
                    </vs-collapse-item>

                </vs-collapse>

                <vs-divider/>

                <div>
                  <h5><strong>Shipping Address</strong></h5>

                  <div class="mt-4">
                    <p>{{ buyerName }}</p>
                    <p class="mt-2">{{ buyerEmail }}</p>
                    <p class="mt-2">{{ buyerPhone }}</p>
                    <!--<p class="mt-2">buyerCompany{{ buyerCompany }}</p>-->
                    <p class="mt-2">{{ buyerAddress }}</p>
                    <!--<p class="mt-2">buyerAddressTwo{{ buyerAddressTwo }}</p>-->
                    <p class="mt-2">{{ buyerPostcode }} , {{ buyerArea }}</p>
                    <p class="mt-2">{{ buyerState }} , {{ buyerCountry }}</p>
                  </div>

                  <vs-divider/>

                  <!--<h5><strong>Billing Address</strong></h5>-->

                  <!--<div class="mt-4">
                    <p>buyerName{{ buyerName }}</p>
                    <p class="mt-2">email@email.com{{ buyerEmail }}</p>
                    <p class="mt-2">buyerCompany{{ buyerCompany }}</p>
                    <p class="mt-2">buyerAddressOne{{ buyerAddressOne }}</p>
                    <p class="mt-2">buyerAddressTwo{{ buyerAddressTwo }}</p>
                    <p class="mt-2">buyerPostcode{{ buyerPostcode }}, buyerTown{{ buyerTown }}</p>
                    <p class="mt-2">buyerState{{ buyerState }}, buyerCountry{{ buyerCountry }}</p>
                  </div>-->

                  <vs-divider/>

                  <h5><strong>Choose Payment Method</strong></h5>

                  <v-select :options="paymentOptions" :clearable="false" v-model="paymentMethod" v-on:input="changeItem" class="mt-4"/>

                  <vs-divider/>

                  <div class="card-container" v-show="creditcardpayment===1">
                    <div class="form">
                      <vs-input 
                        id="name"
                        placeholder="Card Holder Name"
                        v-model="name"
                        name="Name"
                        v-validate="'required|alpha_spaces'"
                        class="w-full mt-6"/>
                      <span class="text-danger text-sm" >{{ errors.first('Name') }}</span>
                      <div class="mt-5" @change="complete = this.$event.complete" ref="card"></div>

                      <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
                      <br/>
                      <small>By placing order, I agree to the Quicksend.asia <a>Terms of Service</a>, <a>Privacy Policy</a> and <a>Refund Policy</a>.</small>

                      <vs-button  class="w-full mt-6" ref="loadingbutton" @click.stop="payNow()" >Pay Now</vs-button>
                      <!--<vs-button v-show="is_successful" class="w-full mt-6" ref="loadingbutton">Continue</vs-button>-->
                      <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
                    </div>  
                  </div>
                  

                  <div class="centerx mt-4 text-center" v-show="codpayment===1">
                    <small>By placing order, I agree to the Quicksend.asia <a>Terms of Service</a>, <a>Privacy Policy</a> and <a>Refund Policy</a>.</small>
                    <vs-button class="w-full mt-2 shadow-md" type="filled" icon-pack="feather" icon="icon-arrow-right" @click.stop="paywithCOD()">Confirm Order</vs-button>
                    <vs-popup title="COD instruction details" :active.sync="popupViewCOD">
                      <table style="width:100%;">
                        <tr>
                          <td><span>{{codremark}}</span></td>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <vs-button color="primary" type="filled" @click="popupViewCOD=false">Close</vs-button>
                            <vs-button color="primary" type="filled" @click="paywithCOD(1);">Confirm</vs-button>
                          </td>
                        </tr>
                      </table>
                    </vs-popup>
                  </div>


                  <div class="card-container" v-show="stripepayment===1">
                    <div class="form">
                      <vs-input 
                        id="name"
                        placeholder="Card Holder Name"
                        v-model="name"
                        name="Name"
                        v-validate="'required|alpha_spaces'"
                        class="w-full mt-6"/>
                      <span class="text-danger text-sm" >{{ errors.first('Name') }}</span>
                      <div class="mt-5" @change="complete = this.$event.complete" ref="stripe"></div>

                      <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
                      <br/>
                      <small>By placing order, I agree to the Quicksend.asia <a>Terms of Service</a>, <a>Privacy Policy</a> and <a>Refund Policy</a>.</small>

                      <vs-button  class="w-full mt-6" ref="loadingbutton" @click.stop="payNow()" >Pay Now</vs-button>
                      <!--<vs-button v-show="is_successful" class="w-full mt-6" ref="loadingbutton">Continue</vs-button>-->
                      <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
                    </div> 
                  </div>

                  <div class="card-container" v-show="stripefpxpayment===1">
                    <div class="form">
                      FPX Bank
                      <div class="mt-5" @change="complete = this.$event.complete" ref="fpxbank"></div>

                      <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
                      <br/>
                      <small>By placing order, I agree to the Quicksend.asia <a>Terms of Service</a>, <a>Privacy Policy</a> and <a>Refund Policy</a>.</small>

                      <vs-button  class="w-full mt-6" ref="loadingbutton" @click.stop="payFPXNow()" >Pay Now</vs-button>
                      <!--<vs-button v-show="is_successful" class="w-full mt-6" ref="loadingbutton">Continue</vs-button>-->
                      <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
                    </div> 
                  </div>




                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <vx-card title="" title-color="primary" v-if="!showOrder">
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg" >
              <div class="p-6">
                <div>
                  <h5>Order Already Paid or You may not have access to this order</h5>
                  Click Here to back
                  <vs-button  class="w-full mt-6" @click.stop="back()" >Back</vs-button>
                </div>
              </div>
              </div>
          </div>
        </div>
      </vx-card>

      

    </div>
    <div class="vx-col w-full sm:w-3/4 md:w-2/3 lg:w-3/4 xl:w-3/5" v-if="showDone">
      <vx-card title="" title-color="primary" >
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg" >
              <div class="p-6">
                <div>
                  <h5>Payment Complete.</h5>
                  Thank you for the payment. Click Here to back
                  <vs-button  class="w-full mt-6" @click.stop="back()" >Back</vs-button>
                </div>
              </div>
              </div>
          </div>
        </div>
      </vx-card>
    </div>

    
  </div>
</template>
<script src="https://js.stripe.com/v3/"></script>

<script>
//var stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import vSelect from 'vue-select';
import axios from '@/axios';
import router from '@/router';
import { CardNumber, CardExpiry, CardCvc } from 'vue-stripe-elements-plus'

let stripe = null,
card = null,
fpxBank = null;
let style = {
    base: {
      iconColor: '#F9278E',
      color: '#F9278E',
      fontWeight: 500,
      fontFamily: 'inherit',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      '::placeholder': {
        color: '#CFD7DF',
      },
    }
}

const dialogs = {
  invalidPayment: (error) => {
    if (_.isEmpty(error)) error = "Sorry, we are not able to process your payment";

    return {
      color: "danger", 
      title: "Opps, Payment Failed",
      text: error,
      accept: () => {
        //console.dir(error); // intentional for debug
      }
    }
  },
}

export default {
  components: {
    vSelect
  },
  data(){
    return {
      showDone:false,
      showOrder:true,
      paymentMethod: { label: 'Choose your payment method', value: '' },
      paymentOptions: [],
      buyerEmail:"",
      buyerName:"",
      buyerPostcode:"",
      buyerState:"",
      buyerArea:"",
      buyerCountry:"Malaysia",
      buyerAddress:"",
      buyerPhone:"",
      stateOptions:[
      { id: "PLS", label: "Perlis" },
      { id: "KDH", label: "Kedah" },
      { id: "PNG", label: "Pulau Pinang" },
      { id: "KTN", label: "Kelantan" },
      {id:"TRG", label:"Terengganu"},
      {id:"PHG", label:"Pahang"},
      {id:"PRK", label:"Perak"},
      {id:"SGR", label:"Selangor"},
      {id:"KUL", label:"Kuala Lumpur"},
      {id:"PJY", label:"PutraJaya"},
      {id:"NSN", label:"Negeri Sembilan"},
      {id:"MLK", label:"Melaka"},
      {id:"JHR", label:"Johor"},
      {id:"LBN", label:"Labuan"},
      {id:"SBH", label:"Sabah"},
      {id:"SRW", label:"Sarawak"}
      ],
      productTotalAmount:"",
      grandTotal:"0.00",
      discount:"0.00",
      subTotal:"0.00",
      shippingLabel:"",
      shippingFees:"0.00",
      products:[],
      stripeAPIToken: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      stripe: '',
      elements: '',
      card: '',
      checkoutsession : '',
      name:'',
      showCreditCard: false,
      popupCreditCard: false,
      message: '',
      is_successful: false,
      clientSecret:'',
      paymentIntent:'',
      creditcardpayment:0,
      codpayment:0,
      stripepayment:0,
      stripefpxpayment:0,
      payment_error_message:'',
      payment_result:'',
      payment_details:{},
      codremark:'', // cod instruction, if not empty will show user in popup
      popupViewCOD:false
    }
  },
  mounted() {
  },
  created() {
    this.getorderDetail();
  },
  watch:{
    creditcardpayment: async function(val){
      if(val){
        this.$vs.loading()
        stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
        await this.getQSSecretKey();
        var elements = stripe.elements();
        card = elements.create('card',{style, hidePostalCode: true});
        card.mount(this.$refs.card);
        this.$vs.loading.close();
      }
    },
    stripepayment: async function(val){
      if(val){
        this.$vs.loading()
        let account_id = JSON.parse(this.paymentMethod.api_field_values).account_id;
        stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY, {stripeAccount: account_id})
        await this.getStripeSecretKey();
        var elements = stripe.elements();
        card = elements.create("card",{style, hidePostalCode: true});
        card.mount(this.$refs.stripe);
        this.$vs.loading.close();
      }
    },
    stripefpxpayment: async function(val){
      if(val){
        this.$vs.loading()
        // let account_id = JSON.parse(this.paymentMethod.api_field_values).account_id;
        stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
        await this.getStripeFPXSecretKey();
        var elements = stripe.elements();
        var fpxstyle = {
          base: {
            // Add your base input styles here. For example:
            padding: '10px 12px',
            color: '#32325d',
            fontSize: '16px',
          },
        };

        // Create an instance of the fpxBank Element.
        fpxBank = elements.create(
          'fpxBank',
          {
            style: fpxstyle,
            accountHolderType: 'individual',
          }
        );
        fpxBank.mount(this.$refs.fpxbank);
        this.$vs.loading.close();
      }
    },
  },
  methods : {
    async getQSSecretKey(){
      let order_id = this.$route.params.orderid;
      let result = await axios.get('/card/public_init_pay_order_card/'+order_id);
     
      Object.entries(result.data.data).forEach(([key, val]) => {
        this.clientSecret=val.client_secret;
      });

    },
    async getStripeSecretKey(){
      let order_id = this.$route.params.orderid;
      let result = await axios.get('/card/public_init_pay_order_stripe/'+order_id);
     
      Object.entries(result.data.data).forEach(([key, val]) => {
        this.clientSecret=val.client_secret;
      });

    },
    async getStripeFPXSecretKey(){
      let order_id = this.$route.params.orderid;
      let result = await axios.get('/card/public_init_pay_order_fpx/'+order_id);
      Object.entries(result.data.data).forEach(([key, val]) => {
        this.clientSecret=val.client_secret;
        this.paymentIntent=val.payment_intent;
      });

    },
    async getorderDetail(){
      let order_id = this.$route.params.orderid;
      try {
        let result = await axios.get('/order/thirdstep/'+order_id);
        let res=result.data.data;
        if(result.data.data.status != 1){
          this.showOrder = false;
        }else{
          this.showOrder          = true;
          this.buyerName          = res.name;
          this.buyerPhone         = res.country_code+res.phone;
          this.buyerPostcode      = res.postcode;
          this.productTotalAmount = res.total_amount;
          this.buyerAddress       = res.address;
          this.buyerArea          = res.area;
          this.email              = res.email;
          Object.entries(this.stateOptions).forEach(([key, val]) => {
            if(val.id==res.state_code){
              this.buyerState=val.label;
            }
          });

          let subTotal = parseFloat(res.subtotal_amount);
          let shipping_fees = parseFloat(res.shipping.shipping_fees);
          if (isNaN(subTotal)) subTotal = 0;
          if (isNaN(shipping_fees)) shipping_fees = 0;

          this.shippingLabel = res.shipping.name;
          this.shippingFees  = res.shipping.shipping_fees;
          this.subTotal      = subTotal + shipping_fees;
          
          let total_discount = res.order_products.reduce((disc, cur) => {
            let cur_disc = parseFloat(cur.discount);
            if (isNaN(cur_disc)) cur_disc = 0;
            return disc + cur_disc;
          }, 0);

          this.discount       = total_discount;
          this.grandTotal     = this.subTotal - this.discount;
          this.products       = res.order_products;
          this.paymentOptions = res.payment_option;
        }
      }
      catch (e) {
        throw e;
        // console.log(e);
          //this.$vs.dialog(dialogs.invalidCoverage());
      }
    },
    changeItem:function(){
      if(this.paymentMethod.payment_gateway_id===4){
        this.creditcardpayment=1;
        this.codpayment=0;
        this.stripepayment=0;
      }else if(this.paymentMethod.payment_gateway_id===2){
        this.creditcardpayment=0;
        this.codpayment=1;
        this.stripepayment=0;
      }else if(this.paymentMethod.payment_gateway_id===3){
        this.creditcardpayment=0;
        this.codpayment=0;
        this.stripepayment=1;
      }else if(this.paymentMethod.payment_gateway_id===5){
        this.creditcardpayment=0;
        this.codpayment=0;
        this.stripepayment=0;
        this.stripefpxpayment=1;
      }
    },
    async paymentSuccess(){
      // this part will call to update payment details
      let res = await this.$store.dispatch('order/complete_payment',this.payment_details);
      if(res){
        this.showDone = true; // change to showDone panel
      }
    },
    async payNow(){ // for stripe usage , both quicksendpay / stripe connect using same
      this.$vs.loading()
      this.payment_result=await stripe.confirmCardPayment(this.clientSecret, {
        payment_method: {
          card: card,
          billing_details: {
            name: this.buyerName
          }
        }
      }).then(function(result) {
        if (result.error) {
          // Show error to your customer (e.g., insufficient funds)
          //console.log(result);
          return result;
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            // Show a success message to your customer
            // There's a risk of the customer closing the window before callback
            // execution. Set up a webhook or plugin to listen for the
            // payment_intent.succeeded event that handles any business critical
            // post-payment actions.
            // console.log(result);
            return result;
          }
        }
      });
      this.$vs.loading.close();
      // console.log(this.payment_result);
      if(this.payment_result.error){
        this.$vs.dialog(dialogs.invalidPayment(this.payment_result.error.message));
      }else{
        this.payment_details = {
          order_id : this.$route.params.orderid,
          amount : (this.payment_result.paymentIntent.amount/100),
          payment_gateway_id : this.paymentMethod.payment_gateway_id,
          status : 1,
          payment_transaction : this.payment_result.paymentIntent.id,
          payment_attachment : this.payment_result.paymentIntent
        };
        if (this.paymentMethod.api_field_values != "" && typeof this.paymentMethod.api_field_values !== 'undefined') {
          this.payment_details.api_field_values = this.paymentMethod.api_field_values;
        }
        this.paymentSuccess();
      }

    },
    async payFPXNow(){ // for stripe usage , both quicksendpay / stripe connect using same
      this.$vs.loading();
      stripe.confirmFpxPayment(this.clientSecret, {
        payment_method: {
          fpx: fpxBank,
        },
        // Return URL where the customer should be redirected after the authorization
        return_url: `${window.location.origin}/#/summary/complete/${this.$route.params.orderid}/`,
      }).then((result) => {
        if (result.error) {
          // Inform the customer that there was an error.
          var errorElement = document.getElementById('error-message');
          errorElement.textContent = result.error.message;
        }
      });
      this.$vs.loading.close();
    },
    async paywithCOD(trigger=0){
      let remark = JSON.parse(this.paymentMethod.api_field_values);
      if(!trigger && (remark !== null && typeof remark.remarks !== 'undefined' && remark.remarks !== '')){
        // show popup if got cod instruction.
        this.codremark = remark.remarks;
        this.popupViewCOD = true;
      }else{
        this.popupViewCOD=false;
        this.payment_details = {
          order_id : this.$route.params.orderid,
          amount : this.grandTotal,
          payment_gateway_id : this.paymentMethod.payment_gateway_id,
          status : 0,
        };
        if (this.paymentMethod.api_field_values != "" && typeof this.paymentMethod.api_field_values !== 'undefined') {
          this.payment_details.api_field_values = this.paymentMethod.api_field_values;
        }
        setTimeout(this.paymentSuccess,1000);
      }
    },
    back(){
      location.href=window.location.origin;
    }
  }
}

</script>
<style scoped>
.credit-card-inputs.complete {
  border: 2px solid green;
}

@media screen and (max-width: 900px) {
    .img{
        display:none;
    }
    .container{
        grid-template-columns: 1fr;
    }
    .card-container{
        justify-content: center;
    }
}
</style>
